module.exports = __webpack_public_path__ + "media/StudentAdvice_Roscene.64786a6d.mp4";